<template>
    <div>
        <v-card
            style="background-color: transparent"
            elevation="0"
            v-show="globalStep === 'start' || globalStep === 'loan'"
            class="mx-0"
        >
            <v-card-title
                :class="
                    !$vuetify.display.mobile
                        ? 'title font-weight-regular justify-center'
                        : 'body-1 font-weight-regular pa-1'
                "
            >
                {{ wizardStepTitle }}
            </v-card-title>
            <v-window v-model="wizardStep" touchless style="min-height: 27vh">
                <v-window-item :value="1">
                    <v-card-text class="py-0">
                        <v-list subheader lines="two" class="space-y-2">
                            <v-list-item
                                v-if="
                                    enableImportSalesInvoice ||
                                    enableSalesInvoice ||
                                    enablezTillReceipt
                                "
                                id="ODOptionAddDocument"
                                :class="getMobileViewClasses"
                                @click="wizardStep = 3"
                            >
                                <v-list-item-title>Recettes</v-list-item-title>
                                <v-list-item-subtitle>
                                    Ajouter des recettes (ventes, z de caisse)
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon data-cy="DocumentWizard-recettes"
                                        >$chevron_right</v-icon
                                    >
                                </template>
                            </v-list-item>
                            <v-list-item :class="getMobileViewClasses" @click="wizardStep = 2">
                                <v-list-item-title>Dépenses</v-list-item-title>
                                <v-list-item-subtitle>
                                    Ajouter des dépenses (achats, notes de frais,...)
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon data-cy="DocumentWizard-depenses"
                                        >$chevron_right</v-icon
                                    >
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="bankTransactionImp"
                                :class="getMobileViewClasses"
                                @click="wizardStep = 8"
                            >
                                <v-list-item-title>Banque</v-list-item-title>
                                <v-list-item-subtitle>
                                    Importer un relevé bancaire
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon data-cy="DocumentWizard-banque">$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="enablePaySlip"
                                @click.stop="startUpload('PAY_SLIP')"
                            >
                                <v-list-item-title>
                                    Importer des bulletins de salaires
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Prenez une photo ou importez vos bulletins de salaires
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="
                                    !$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                "
                                @click="wizardStep = 6"
                            >
                                <!-- <template v-if="!$vuetify.display.mobile">
                                    <v-icon class="secondary white--text"> trending_up </v-icon>
                                </template> -->

                                <v-list-item-title>Échéancier</v-list-item-title>
                                <v-list-item-subtitle>
                                    Ajouter un échéancier ( Abonnement, emprunt, crédit-bail )
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                @click="wizardStep = 7"
                                v-if="
                                    !$vuetify.display.mobile &&
                                    !isAutonomousUser &&
                                    !isIncomingOutgoingPayment
                                "
                                data-cy="document-wizard-createAccountingItem"
                            >
                                <!-- <template v-if="!$vuetify.display.mobile">
                                    <v-icon class="secondary white--text"> trending_up </v-icon>
                                </template> -->

                                <v-list-item-title>Divers</v-list-item-title>
                                <v-list-item-subtitle>
                                    Ajouter une opération diverse
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                @click="startMiscellaneous"
                                v-else-if="!isAutonomousUser && !isIncomingOutgoingPayment"
                                data-cy="document-wizard-createAccountingItem"
                            >
                                <!-- <template v-if="!$vuetify.display.mobile">
                                    <v-icon class="secondary white--text"> trending_up </v-icon>
                                </template> -->

                                <v-list-item-title>Document divers</v-list-item-title>
                                <v-list-item-subtitle>
                                    Ajoutez un document divers
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="2">
                    <v-card-text class="py-0">
                        <v-list subheader lines="two">
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="
                                    currentUser.profile.configuration.document.importPurchaseInvoice
                                "
                                @click.stop="startUpload('PURCHASE_INVOICE')"
                            >
                                <!-- <template
                                v-if="!$vuetify.display.mobile"
                                >
                                <v-icon
                                class="new_red white--text"
                                >trending_down</v-icon>
                                </template> -->

                                <v-list-item-title>
                                    Importer des factures d'achat
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Prenez une photo ou importez vos factures
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon data-cy="DocumentWizard-factureAchat">
                                        $chevron_right
                                    </v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="
                                    currentUser.profile.configuration.document
                                        .importPurchaseInvoice && !isBNC
                                "
                                @click.stop="startUpload('CURRENT_ACCOUNT')"
                            >
                                <!-- <template
                                v-if="!$vuetify.display.mobile"
                                >
                                <v-icon
                                class="new_red white--text"
                                >trending_down</v-icon>
                                </template> -->

                                <v-list-item-title>
                                    Importer des achats avancés par un associé
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Prenez une photo ou importez vos achats avancés par un associé
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="
                                    currentUser.profile.configuration.document
                                        .importPurchaseInvoice && isBNC
                                "
                                @click.stop="startUpload('OPERATOR_ACCOUNT')"
                            >
                                <!-- <template
                                v-if="!$vuetify.display.mobile"
                                >
                                <v-icon
                                class="new_red white--text"
                                >trending_down</v-icon>
                                </template> -->

                                <v-list-item-title>
                                    Importer des achats payés par l'exploitant
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Prenez une photo ou importez vos achats payés par l'exploitant
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="isBNC"
                                @click.stop="createBncExpense()"
                            >
                                <v-list-item-title>
                                    Ajouter une dépense sans facture payée par l'exploitant
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Si vous avez perdu votre facture, renseignez les informations
                                    nécessaires de votre facture
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="isBNC"
                                @click.stop="startUpload('MISCELLANEOUS')"
                            >
                                <v-list-item-title> Ajouter un document divers </v-list-item-title>
                                <v-list-item-subtitle>
                                    Tableau d'amortissement d'emprunt etc...
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="
                                    (currentUser.profile.configuration.expenseReport.write ||
                                        currentUser.profile.configuration.expenseReport
                                            .writeOnlySelf) &&
                                    (!selectedCompany.profile ||
                                        selectedCompany.profile.createExpenseReport)
                                "
                                @click.stop="globalStep = 'expenseReport'"
                            >
                                <!-- <template
                                v-if="!$vuetify.display.mobile"
                                >
                                <v-icon
                                class="new_red white--text"
                                >trending_down</v-icon>
                                </template> -->

                                <v-list-item-title>Créer une note de frais</v-list-item-title>
                                <v-list-item-subtitle>
                                    Déclarez une note de frais ainsi que vos frais kilométriques
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="3">
                    <v-card-text class="py-0">
                        <v-list subheader lines="two">
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="enableImportSalesInvoice"
                                @click.stop="startUpload('SALES_INVOICE')"
                            >
                                <!-- <template
                                v-if="!$vuetify.display.mobile"
                                >
                                <v-icon
                                class="secondary white--text"
                                >trending_up</v-icon>
                                </template> -->

                                <v-list-item-title>
                                    Importer des factures de vente
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Prenez une photo de votre facture ou importez un document
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon data-cy="DocumentWizard-factureVente"
                                        >$chevron_right</v-icon
                                    >
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="enableSalesInvoice && !$vuetify.display.mobile"
                                @click="wizardStep = 4"
                            >
                                <!-- <template
                                v-if="!$vuetify.display.mobile"
                                >
                                <v-icon
                                class="secondary white--text"
                                >trending_up</v-icon>
                                </template> -->

                                <v-list-item-title> Créer une facture de vente </v-list-item-title>
                                <v-list-item-subtitle>
                                    Utilisez notre éditeur de facture pour créer vos factures de
                                    ventes
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="enablezTillReceipt"
                                @click.stop="createZTill()"
                            >
                                <!-- <template
                                v-if="!$vuetify.display.mobile"
                                >
                                <v-icon
                                class="secondary white--text"
                                >trending_up</v-icon>
                                </template> -->

                                <v-list-item-title>
                                    Créer ou importer un Z de caisse
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Vous êtes commerçant ? Vous gérez une ou plusieurs caisse(s) ?
                                    Ajoutez vos Z de caisse ici.
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="
                                    currentUser.profile.configuration.document
                                        .importMultiSalesInvoice
                                "
                                :class="getMobileViewClasses"
                                @click="activeSaleInvoices = true"
                            >
                                <v-list-item-title>
                                    Importer un fichier de ventes
                                </v-list-item-title>
                                <v-list-item-subtitle>fichier .csv</v-list-item-subtitle>
                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="
                                    currentUser.profile.configuration.document.importPurchaseInvoice
                                "
                                @click="wizardStep = 5"
                            >
                                <v-list-item-title>
                                    Importer un fichier à découper
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Faire l'import d'un fichier à découper
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="4">
                    <v-card-text class="py-0">
                        <v-list subheader lines="three">
                            <v-list-item
                                :class="getMobileViewClasses"
                                @click.stop="
                                    createSalesInvoice();
                                    invoiceType = 'quotation';
                                "
                                id="CreationOfDocument"
                                @click="wizardStep = 5"
                            >
                                <!-- <template
                                v-if="!$vuetify.display.mobile"
                                >
                                <v-icon
                                class="secondary white--text"
                                >trending_up</v-icon>
                                </template> -->

                                <v-list-item-title>Créer un devis</v-list-item-title>
                                <v-list-item-subtitle>
                                    Pour détailler les prestations proposées ainsi que leur prix à
                                    vos clients
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="enableSalesInvoice"
                                @click.stop="(createSalesInvoice(), (invoiceType = 'invoice'))"
                            >
                                <v-list-item-title>Créer une facture</v-list-item-title>
                                <v-list-item-subtitle>
                                    Pour détailler la nature, la quantité et les conditions des
                                    achats et ventes de marchandises ou prestations de services.
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="
                                    (!selectedCompany.profile ||
                                        selectedCompany.profile.createSalesInvoice) &&
                                    !$vuetify.display.mobile
                                "
                                @click.stop="(createSalesInvoice(), (invoiceType = 'billDelivery'))"
                            >
                                <v-list-item-title>Créer un bon de livraison</v-list-item-title>
                                <v-list-item-subtitle>
                                    Pour attester que les marchandises achetées ont bien été livrées
                                    et réceptionnées par votre client
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="5">
                    <v-card-text class="py-0">
                        <v-list subheader lines="two">
                            <v-list-item
                                :class="getMobileViewClasses"
                                @click.stop="startUpload('UNKNOWN', undefined, true)"
                            >
                                <v-list-item-title>
                                    Factures à découper automatiquement
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Importer vos factures PDF à découper automatiquement à l'aide du
                                    tampon bobbee
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                @click.stop="startUpload('UNKNOWN', undefined, false)"
                            >
                                <v-list-item-title>
                                    Factures à découper manuellement
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Importer vos factures PDF à découper
                                </v-list-item-subtitle>

                                <template #append>
                                    <v-icon>$chevron_right</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="6">
                    <v-card-text class="py-0">
                        <v-list subheader lines="two">
                            <v-list-item
                                :class="getMobileViewClasses"
                                @click="globalStep = 'subscription'"
                            >
                                <v-list-item-title>Abonnement</v-list-item-title>
                                <v-list-item-subtitle>
                                    Ajouter un nouvel abonnement
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="isAccountingUser"
                                :class="getMobileViewClasses"
                                @click="openLoanPage()"
                            >
                                <v-list-item-title>Emprunt</v-list-item-title>
                                <v-list-item-subtitle>
                                    Ajouter un nouvel emprunt
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="isAccountingUser"
                                :class="getMobileViewClasses"
                                @click.stop="openLeasingPage()"
                            >
                                <v-list-item-title>Crédit-Bail</v-list-item-title>
                                <v-list-item-subtitle>
                                    Ajouter un nouveau crédit-bail
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="7">
                    <v-card-text class="py-0">
                        <v-list subheader lines="two">
                            <v-list-item
                                :class="getMobileViewClasses"
                                v-if="
                                    currentUser.profile.configuration.document.importPurchaseInvoice
                                "
                                @click.stop="startUpload('MISCELLANEOUS')"
                            >
                                <v-list-item-title>Importer un fichier divers</v-list-item-title>
                                <v-list-item-subtitle>
                                    Faire l'import d'un fichier divers
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                :class="getMobileViewClasses"
                                @click="startMiscellaneousOperation"
                                v-if="
                                    !$vuetify.display.mobile &&
                                    !isAutonomousUser &&
                                    !isIncomingOutgoingPayment
                                "
                            >
                                <v-list-item-title>
                                    Ajouter une écriture manuellement
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    Ajout des écritures manuellement
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="8">
                    <v-card-text class="py-0">
                        <v-list v-if="bankTransactionImp">
                            <v-list-item
                                ripple
                                class="oss-list-item-xl mb-2 py-3"
                                @click="wizardStep = 9"
                                data-cy="DocumentWizard-importBankForm-csv"
                            >
                                <v-list-item-title>
                                    Importer un fichier Excel ou CSV
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-wrap">
                                    Importez les relevés bancaires provenant d'un fichier fourni par
                                    le site internet de votre banque au format Excel, .csv ou .tsv
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon size="x-small" color="light_grey"
                                        >$fa-chevron-right</v-icon
                                    >
                                </template>
                            </v-list-item>
                            <v-list-item
                                ripple
                                class="oss-list-item-xl mb-2 py-3"
                                @click="wizardStep = 10"
                                data-cy="DocumentWizard-importBankForm-ofx"
                            >
                                <v-list-item-title>
                                    Importer un fichier OFX (Open Financial Exchange)
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-wrap">
                                    Importez les relevés bancaires provenant d'un fichier fourni par
                                    le site internet de votre banque au format OFX
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon size="x-small" color="light_grey"
                                        >$fa-chevron-right</v-icon
                                    >
                                </template>
                            </v-list-item>
                            <v-list-item
                                ripple
                                class="oss-list-item-xl mb-2 py-3"
                                @click="wizardStep = 11"
                                data-cy="DocumentWizard-importBankForm-pdf"
                            >
                                <v-list-item-title>
                                    Importer un fichier PDF (non recommandé)
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-wrap">
                                    Importez les relevés bancaires depuis un fichier pdf (essayez
                                    d'éviter les annotations manuscrites)
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon size="x-small" color="light_grey"
                                        >$fa-chevron-right
                                    </v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-window-item>
                <v-window-item :value="9">
                    <BankTransactionImport
                        v-if="bankTransactionImp && wizardStep === 9"
                        :scanBank="false"
                        :title="'Sélectionnez l\'export bancaire à importer (.csv, .xlsx, .tsv .txt)'"
                        :actions="actions"
                        :documentType="'BANK_STATEMENT'"
                        @documentImported="onClose()"
                        @back="onBack()"
                    />
                </v-window-item>
                <v-window-item :value="10">
                    <BankTransactionImport
                        v-if="bankTransactionImp && wizardStep === 10"
                        :scanBank="false"
                        :ofx="true"
                        :title="'Sélectionnez l\'export OFX à importer'"
                        :actions="actions"
                        :documentType="'BANK_STATEMENT'"
                        @documentImported="onClose()"
                        @back="onBack()"
                    />
                </v-window-item>
                <v-window-item :value="11">
                    <UploadDocuments
                        v-if="bankTransactionImp && wizardStep === 11"
                        :showFirstPrevious="true"
                        :companyId="companyId"
                        :documentType="'BANK_STATEMENT'"
                        :multiple="true"
                        :freeTag="false"
                        :inExtensions="['pdf']"
                        :actions="actions"
                        @back="onBack()"
                        @files-uploaded="onClose()"
                    >
                    </UploadDocuments>
                </v-window-item>
                <!-- <v-window-item :value="12">
                    <v-card-text class="py-0">
                        <v-list subheader lines="two">
                            <v-list-item
                                v-if="isAccountingUser  && localEnv === 'dev'"
                                :class="getMobileViewClasses"
                                @click.stop="openLoanOcr()"
                            >
                                <v-list-item-title>Importer un emprunt</v-list-item-title>
                                <v-list-item-subtitle>
                                    Prenez une photo ou importez le document fourni par la banque
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item>
                            <v-list-item
                                v-if="isAccountingUser"
                                :class="getMobileViewClasses"
                                @click.stop="openLoanPage()"
                            >
                                <v-list-item-title>Ajouter un emprunt manuellement</v-list-item-title>
                                <v-list-item-subtitle>
                                    Renseignez-vous même les caractéristiques de l'emprunt
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon size="x-small">$fa-chevron-right</v-icon>
                                </template>
                            </v-list-item> 
                        </v-list>
                    </v-card-text>
                </v-window-item> -->
            </v-window>
        </v-card>
        <UploadDocuments
            ref="uploadDocuments"
            v-if="globalStep === 'uploadDocuments'"
            :showFirstPrevious="!showFirstPrevious && inGlobalStep === '' ? false : true"
            :companyId="companyId"
            :documentId="documentId"
            :documentType="workingDocumentType"
            :creditNote="creditNote"
            :automaticSplit="automaticSplit"
            :multiple="multiple"
            :inExtensions="inExtensions"
            :showActionsBtn="showActionsBtn"
            :actions="actions"
            :disableAutoOpenFileDialog="false"
            :ownerId="ownerId"
            @back="onBack"
            @files-uploaded="onFilesUploaded"
            @new-document="onNewDocument"
        />
        <TicketZEditionWizard
            ref="zTillReceipt"
            v-if="globalStep === 'zTillReceipt'"
            :companyId="companyId"
            :showFirstPrevious="
                !showFirstPrevious && inGlobalStep === 'zTillReceipt' ? false : true
            "
            :dialog="dialog"
            :showActionsBtn="showActionsBtn"
            :actions="actions"
            @back="onBack"
            @created="onZTillReceiptCreated"
            class="px-3"
        />
        <ExpenseReportWizard
            ref="expenseReport"
            v-if="globalStep === 'expenseReport'"
            :companyId="companyId"
            :showFirstPrevious="
                !showFirstPrevious && inGlobalStep === 'expenseReport' ? false : true
            "
            :dialog="dialog"
            :showActionsBtn="showActionsBtn"
            :actions="actions"
            :openCameraOnly="openCameraOnly"
            @back="onBack"
            @created="onExpenseReportCreated"
        />
        <InvoiceEditWizard
            ref="invoice"
            v-if="globalStep === 'invoice'"
            :dialog="dialog"
            :companyId="companyId"
            :invoiceType="invoiceType"
            :showActionsBtn="showActionsBtn"
            :actions="actions"
            @back="onBack"
            @validAction="validAction($event)"
        />
        <IncomingOutgoingPaymentExpense
            v-if="globalStep === 'bncExpense'"
            :companyId="companyId"
            @back="onBack"
            @close="onClose"
            :actions="actions"
        />
        <Subscriptions
            ref="subscription"
            v-model="subscriptionsDialog"
            v-if="globalStep === 'subscription'"
            :companyId="selectedCompany.id"
            :actions="actions"
            @back="onBack"
            @close="onClose"
        >
        </Subscriptions>
        <SalesInvoice
            v-model="activeSaleInvoices"
            v-if="activeSaleInvoices"
            @salesInvoiceImported="activeSaleInvoices = false"
        />
    </div>
</template>

<script lang="ts">
import { User } from "../../store/store";

import TicketZEditionWizardComp, {
    TicketZEditionWizard,
} from "../zTillReceipt/TicketZEditionWizard.vue";
import ExpenseReportWizard from "../expenseReport/ExpenseReportWizard.vue";
import UploadDocumentsComp, { UploadDocuments } from "./UploadDocuments.vue";
import InvoiceEditWizard from "../invoice/InvoiceWizard.vue";
import IncomingOutgoingPaymentExpense from "../IncomingOutgoingPaymentExpense.vue";
import Subscriptions from "../subscriptions/SubscriptionsForm.vue";
import { Component, Vue, toNative, Prop, Watch, Ref } from "vue-facing-decorator";
import ZTillReceiptComp from "../zTillReceipt/ZTillReceipt.vue";
import ExpenseReportComp, { ExpenseReport } from "../expenseReport/ExpenseReport2.vue";
import InvoiceEditionComp, { InvoiceEdition } from "../invoice/InvoiceEdition.vue";
import { DialogAction } from "@/services/dialogAction";
import SalesInvoice from "../SalesInvoice.vue";
import BankTransactionImport from "../import/BankTransactionImport.vue";
import getEnv from "../../env";

const env = getEnv();

@Component({
    components: {
        TicketZEditionWizard,
        ExpenseReportWizard,
        UploadDocuments: UploadDocumentsComp,
        InvoiceEditWizard,
        IncomingOutgoingPaymentExpense,
        Subscriptions,
        zTillReceipt: ZTillReceiptComp,
        zTillReceiptUpload: TicketZEditionWizardComp,
        InvoiceEdition: InvoiceEditionComp,
        SalesInvoice,
        BankTransactionImport,
    },
    emits: [
        "validAction",
        "globalStep",
        "wizardStep",
        "invoiceType",
        "close",
        "back",
        "files-uploaded",
        "new-document",
        "created",
        "startMiscellaneousOperation",
        "startMiscellaneous",
        "startLoanOcr",
    ],
})
export class DocumentWizard extends Vue {
    @Prop({ default: "" }) readonly companyId: string;
    @Prop({ default: "" }) readonly documentId: string;
    @Prop({ default: "" }) readonly documentType: string;
    @Prop({ default: 0 }) readonly amount: number;
    @Prop({ default: true }) readonly multiple: boolean;
    @Prop({ default: true }) readonly showFirstPrevious: boolean;
    @Prop({ default: "" }) readonly inGlobalStep: string;
    @Prop({ default: null }) readonly inExtensions: any;
    @Prop({ default: true }) readonly dialog: boolean;
    @Prop({ default: null }) actions: { action: DialogAction; [key: string]: any };
    @Prop({ default: false }) readonly openCameraOnly: boolean;
    @Prop({ default: "" }) readonly ownerId: string;

    localEnv = env.environnement;

    subscriptionsDialog = false;

    creditNote: boolean = false;

    activeSaleInvoices = false;

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
        // return this.$store.state.selected_company
    }

    get legalForm() {
        return this.selectedCompany.legalForm;
    }

    validAction(data) {
        this.$emit("validAction", data);
    }

    insideDocumentType: string = "";

    invoiceType = "";

    automaticSplit: boolean = false;

    globalStep_: string = "uploadDocuments";

    get globalStep() {
        return this.globalStep_;
    }

    set globalStep(data) {
        this.globalStep_ = data;
        if (data === "start") {
            if (this.actions && this.actions.action) {
                this.actions.action.display = false;
            }
        }
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    get isAutonomousUser() {
        return this.currentUser?.isAutonomousUser;
    }

    get isIncomingOutgoingPayment() {
        if (
            this.selectedCompany.profile &&
            this.selectedCompany.profile.accountingType === "INCOMING_OUTGOING_PAYMENT"
        ) {
            return true;
        }
        return false;
    }

    get isBNC() {
        return this.selectedCompany?.incomeCategory === "BNC";
    }

    get documentTypes() {
        const ca = this.legalForm !== "EI" ? "CURRENT_ACCOUNT" : "OPERATOR_ACCOUNT";
        const types = ["SALES_INVOICE", "PURCHASE_INVOICE", ca, "PAY_SLIP"];
        return types;
    }

    formatType(type) {
        return this.$tc("document.type." + type);
    }

    get workingDocumentType() {
        return this.insideDocumentType || this.documentType;
    }

    set workingDocumentType(value) {
        this.insideDocumentType = value;
    }

    startUpload(documentType, creditNote: boolean = false, automaticSplit = false) {
        if (documentType) {
            this.workingDocumentType = documentType;
            this.creditNote = creditNote;
            this.automaticSplit = automaticSplit;
            this.globalStep = "uploadDocuments";
        } else {
            this.workingDocumentType = "";
            this.wizardStep = 1;
            this.creditNote = false;
        }
    }

    @Watch("documentType")
    @Watch("amount")
    onDocumentTypeChanged(value) {
        if (this.documentType) {
            if (this.documentType === "UNKNOWN") {
                this.globalStep = "start";
                return (this.wizardStep = 5);
            }
            this.globalStep = "uploadDocuments";
        } else {
            this.globalStep = "start";
            if (this.amount < 0) {
                this.wizardStep = 2;
            } else if (this.amount > 0) {
                this.wizardStep = 3;
            } else {
                this.wizardStep = 1;
            }
        }
    }

    @Watch("globalStep")
    onGlobalStepChanged(value) {
        // debugger;
        // if (this.globalStep === "subscription") {
        //     if (this.actions && this.actions.action) {
        //         this.actions.action.display = true;
        //     }
        // }
        this.$emit("globalStep", this.globalStep);
    }

    @Watch("wizardStep")
    onWizardStepChanged(value) {
        this.$emit("wizardStep", this.wizardStep);
    }

    @Watch("invoiceType")
    onInvoiceTypeChanged(value) {
        this.$emit("invoiceType", this.invoiceType);
    }

    openLeasingPage() {
        this.$router.push({
            name: "leasing",
            params: {
                companyId: this.selectedCompany.id,
            },
        });
    }

    openLoanPage() {
        this.$router.push({
            name: "loan",
            params: {
                companyId: this.selectedCompany.id,
            },
        });
    }

    /**
     * Event for modify documentType for loan ocr
     */
    openLoanOcr() {
        this.$emit("startLoanOcr");
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get showActionsBtn() {
        return !this.$attrs.validAction;
    }

    get bankTransactionImp() {
        if (this.currentUser.profile) {
            if (this.currentUser.profile.configuration) {
                if (this.currentUser.profile.configuration.bankTransaction) {
                    return this.currentUser.profile.configuration.bankTransaction.import;
                }
            }
        }

        return false;
    }

    beforeMount() {
        if (this.inGlobalStep === "zTillReceipt") {
            this.globalStep = this.inGlobalStep;
            this.wizardStep = 3;
        } else if (this.inGlobalStep === "expenseReport") {
            this.globalStep = this.inGlobalStep;
            this.wizardStep = 2;
        } else if (this.inGlobalStep === "loan") {
            this.globalStep = this.inGlobalStep;
            this.wizardStep = 12;
        } else {
            this.onDocumentTypeChanged(this.documentType);
        }
        this.onGlobalStepChanged(this.globalStep);
        this.onWizardStepChanged(this.wizardStep);
        this.onInvoiceTypeChanged(this.invoiceType);
        if (this.actions && this.globalStep === "start") {
            this.actions.action.display = false;
        }
        if (!this.enableSalesInvoice && !this.enablezTillReceipt && !this.enablePaySlip) {
            this.wizardStep = 2;
        }
    }

    // wizard
    wizardStep = 1;
    get wizardStepTitle() {
        switch (this.wizardStep) {
            case 1:
                // return "Voulez-vous ajouter des justificatifs de dépenses ou de recettes ?" ;
                return "Quel type de justificatifs souhaitez-vous ajouter ?";
            case 2:
                return "Choisissez le type de dépenses";
            case 3:
                return "Comment souhaitez-vous ajouter cette recette ?";
            case 4:
                return "Choisissez le type de recettes";
            case 5:
                return "Factures à découper";
            case 6:
                return "Quel type d'échéancier souhaitez-vous ajouter ?";
            case 7:
                return "Choisissez l'option souhaitée";
            case 8:
                return "Importer des relevés bancaires";
            case 9:
                return "Importer un fichier Excel ou CSV";
            case 10:
                return "Importer un fichier OFX";
            case 11:
                return "Importer un fichier PDF";
            case 12:
                return "Comment souhaitez-vous ajouter cet emprunt ?";
        }
        return "Title" + this.wizardStep + " - " + this.globalStep;
    }

    disabledPrevStep() {
        if (this.wizardStep === 1) return true;
        return false;
    }

    @Ref("uploadDocuments") uploadDocuments: UploadDocuments;
    @Ref("zTillReceipt") zTillReceipt: TicketZEditionWizard;
    @Ref("zTillReceiptUpload") zTillReceiptUpload: TicketZEditionWizard;
    @Ref("expenseReport") expenseReport: ExpenseReport;
    @Ref("invoice") invoice: InvoiceEdition;
    next() {
        switch (this.globalStep) {
            case "uploadDocuments":
                this.uploadDocuments.nextStep();
                break;
            case "zTillReceipt":
                this.zTillReceipt.nextStep();
                break;
            case "zTillReceiptUpload":
                this.zTillReceiptUpload.nextStep();
                break;
            case "expenseReport":
                this.expenseReport.next();
                break;
            case "invoice":
                this.invoice.next();
                break;
        }
    }

    previousStep() {
        if (this.amount || this.documentType) {
            this.$emit("close");
        } else if (this.globalStep !== "start") {
            switch (this.globalStep) {
                case "uploadDocuments":
                    this.$refs.uploadDocuments.previousStep();
                    break;
                case "zTillReceipt":
                    this.$refs.zTillReceipt.previousStep();
                    break;
                case "zTillReceiptUpload":
                    this.$refs.zTillReceiptUpload.previousStep();
                    break;
                case "expenseReport":
                    this.$refs.expenseReport.previousStep();
                    break;
                case "invoice":
                    this.$refs.invoice.back();
                    break;
                case "bncExpense":
                    this.onBack();
                    break;
                case "subscription":
                    this.onBack();
                    break;
            }
        } else {
            switch (this.wizardStep) {
                case 1:
                    break;
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    this.wizardStep = 1;
                    break;
                case 9:
                case 10:
                case 11:
                    this.wizardStep = 8;
                    break;
                case 12:
                    this.wizardStep = 6;
                    break;
            }
        }
    }

    createBncExpense() {
        this.globalStep = "bncExpense";
    }

    onClose() {
        this.$emit("close");
    }

    createExpenseReport() {
        this.globalStep = "expenseReport";
    }

    createSalesInvoice() {
        this.globalStep = "invoice";
    }

    createZTill() {
        // this.wizardStep = 5
        this.globalStep = "zTillReceipt";
    }

    onBack() {
        if (this.documentType === "BANK_STATEMENT") {
            this.$emit("back");
            return;
        }
        if (this.documentType) {
            this.$emit("close");
            return;
        }
        this.workingDocumentType = "";
        this.invoiceType = "";
        this.globalStep = "start";
    }

    onFilesUploaded() {
        this.$emit("files-uploaded");
    }

    onNewDocument(data) {
        this.$emit("new-document", data);
    }

    onZTillReceiptCreated() {
        this.$emit("created");
    }

    onExpenseReportCreated() {
        // this.dialog = false;
        if (this.inGlobalStep !== "expenseReport") {
            this.$router.push({
                name: "expenseReports",
            });
        } else {
            this.$emit("created");
        }
    }

    startMiscellaneousOperation() {
        this.$emit("startMiscellaneousOperation");
    }

    startMiscellaneous() {
        this.$emit("startMiscellaneous");
    }

    get enablezTillReceipt() {
        if (!this.selectedCompany) {
            return false;
        }
        if (this.selectedCompany.profile && !this.selectedCompany.profile.createZTillReceipt) {
            return false;
        }
        // if (!this.currentUser?.profile?.configuration.document.write) {
        //     return false
        // }
        return true;
    }

    get enableImportSalesInvoice() {
        if (!this.selectedCompany) {
            return false;
        }
        if (this.selectedCompany.profile && !this.selectedCompany.profile.createSalesInvoice) {
            return false;
        }
        return this.currentUser.profile.configuration.document.importSalesInvoice;
    }

    get enableSalesInvoice() {
        if (!this.selectedCompany) {
            return false;
        }
        if (this.selectedCompany.profile && !this.selectedCompany.profile.createSalesInvoice) {
            return false;
        }
        if (!this.currentUser?.profile?.configuration.salesInvoice.write) {
            return false;
        }
        return true;
    }

    get isAgriculturalCompany() {
        return !!this.selectedCompany?.activities?.find((a) => a.name === "0113Z");
    }

    get enablePaySlip() {
        if (!this.currentUser.profile?.configuration?.document?.importPurchaseInvoice) {
            return false;
        }
        return this.isAgriculturalCompany;
    }

    get getMobileViewClasses(): string {
        return !this.$vuetify.display.mobile
            ? "mb-2 oss-list-item rounded-lg"
            : "mb-2 px-2 oss-list-item rounded-lg";
    }
}

export default toNative(DocumentWizard);
</script>
